<div class="wrapper">
  <div class="widget-wrapper-header">
    <div class="title">
      {{ widget().title | translate }}
    </div>
    <div class="actions">
      <inf-actions-bar
        [actions]="actions()"
        [config]="actionBarConfig"
        (actionClick)="onActionClick($event)"
      />
    </div>
  </div>
  <div class="grid-stack-item-content">
    <ng-content></ng-content>
  </div>
</div>
